// extracted by mini-css-extract-plugin
export var defaultWrapper = "_km-3";
export var downloadButton = "_km-4";
export var fileContainer = "_km-9 _km-7";
export var fileContainerBase = "_km-7";
export var fileContainerBaseSm = "_km-a _km-7";
export var fileContainerFixedHeight = "_km-8 _km-7";
export var fileContainerFixedHeightSm = "_km-c _km-a _km-7";
export var fileContainerSm = "_km-b _km-a _km-7";
export var fileInfo = "_km-5";
export var fileInfoWidthRestricted = "_km-6";
export var fileType = "_km-1";
export var fileTypeName = "_km-2";
export var fileTypeSm = "_km-d _km-1";
export var image = "_km-0";
export var link = "_km-f";
export var overflowEllipsis = "_km-e";